import { useMutation, useQuery } from 'react-query';
import VendorPandadocAPI, {
  CreateVendorDocumentData,
} from '../Api/vendor.pandadoc';

export const useGetVendorDocumentStatus = (
  userId: number,
  documentName: string,
  pandadocId?: string,
) =>
  useQuery(
    ['pandadoc-doc-status', userId, documentName, pandadocId],
    () => VendorPandadocAPI.getVendorDocument(userId, documentName),
    {
      refetchInterval: (data) =>
        !data ||
        !data.status ||
        data.status.includes('draft') ||
        data.status.includes('uploaded')
          ? 5000
          : false,
      staleTime: 0,
      cacheTime: 0,
    },
  );

export const useGetVendorDocumentStatusCompleted = (
  userId: number,
  documentName: string,
  pandadocId?: string,
) =>
  useQuery(
    ['pandadoc-doc-status-completed', userId, documentName, pandadocId],
    () => VendorPandadocAPI.getVendorDocument(userId, documentName),
    {
      refetchInterval: (data) =>
        !data || !data.status || !data.signed_at ? 5000 : false,
      staleTime: 0,
      cacheTime: 0,
    },
  );

// Need to manually use refetch to get the data because of `enabled: false`
export const useGetVendorDocument = (userId: number, documentName: string) =>
  useQuery(
    ['pandadoc-doc', userId, documentName],
    () => VendorPandadocAPI.getVendorDocument(userId, documentName),
    {
      enabled: false,
    },
  );

export const useCreateVendorDocument = () =>
  useMutation(
    async ({
      userId,
      documentName,
      body,
    }: {
      userId: number;
      documentName: string;
      body: CreateVendorDocumentData;
    }) => VendorPandadocAPI.createVendorDocument(userId, documentName, body),
  );

export const useCreateDocumentLink = () =>
  useMutation(
    async ({ userId, documentId }: { userId: number; documentId: string }) =>
      VendorPandadocAPI.createDocumentLink(userId, documentId),
  );
